import { httpClient } from '@/lib/httpClient';

export interface Crm {
  id: number;
  userProfileId: string;
  email?: string;
  name?: string;
  uniqueCatalogIds?: string;
  firstPurchaseDate?: string;
  lastPurchaseDate?: string;
  totalSpent?: number;
  totalSales?: number;
  totalProductsPurchased?: number;
  profile: {
    model: string;
    profile: Record<string, unknown>;
  } | null;
  audienceUser?: {
    audienceId: number;
    audience: {
      id: number;
      name: string;
    };
  }[];
  catalogImages: {
    catalogId: number;
    imageUrl: string;
  }[];
}

export enum PeriodEnum {
  LAST_7_DAYS = 'last_7_days',
  LAST_30_DAYS = 'last_30_days',
  LAST_3_MONTHS = 'last_3_months',
  LAST_6_MONTHS = 'last_6_months',
  LAST_12_MONTHS = 'last_12_months',
  MORE_THAN_12_MONTHS = 'more_than_12_months',
}

export enum SpendingEnum {
  UP_TO_500 = 'up_to_500',
  FROM_500_TO_1000 = '500_to_1000',
  FROM_1000_TO_2500 = '1000_to_2500',
  FROM_2500_TO_5000 = '2500_to_5000',
  ABOVE_5000 = 'above_5000',
  NO_PURCHASES = 'no_purchases',
}

export enum ActiveSinceEnum {
  LESS_THAN_3_MONTHS = 'less_than_3_months',
  FROM_3_TO_6_MONTHS = '3_to_6_months',
  FROM_6_TO_12_MONTHS = '6_to_12_months',
  FROM_1_TO_2_YEARS = '1_to_2_years',
  MORE_THAN_2_YEARS = 'more_than_2_years',
  NEW_CUSTOMERS = 'new_customers',
}

export interface CrmQueryFiltterDto {
  page: number;
  limit: number;
  name?: string;
  email?: string;
  userProfileId?: string;
  period?: PeriodEnum;
  spending?: SpendingEnum;
  activeSince?: ActiveSinceEnum;
}

export interface CrmResponse {
  totalItems: number;
  currentPage: number;
  totalPages: number;
  items: Crm[];
}

class CrmService {
  constructor() {}

  async findAll(queryFilterDto: CrmQueryFiltterDto) {
    const { data } = await httpClient.get<CrmResponse>('/v1/crm', {
      params: queryFilterDto,
    });

    return data;
  }

  async findOne(id: number) {
    const { data } = await httpClient.get<Crm>(`/v1/crm/${id}`);

    return data;
  }
}

export default new CrmService();
